// ABOUTME: Application entry point — mounts React root and wraps providers
// ABOUTME: Auth and React Query providers are initialized here
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import App from './App'
import { ThemeProvider } from './components/providers/ThemeProvider'
import { AvatarStoreProvider } from './lib/store/avatarStore'
import { ShoppingStoreProvider } from './lib/store/shoppingStore'
import { NotificationStoreProvider, setupNotificationSystem } from './services/NotificationService'
import { SocialStoreProvider } from './services/SocialService'
import { SubscriptionStoreProvider } from './services/SubscriptionService'
import { getProviderFromEnv } from './providers'
import './styles/globals.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 30,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

getProviderFromEnv()

setupNotificationSystem()


const root = document.getElementById('root')
if (root) {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <NotificationStoreProvider>
          <SubscriptionStoreProvider>
            <AvatarStoreProvider>
              <ShoppingStoreProvider>
                <SocialStoreProvider>
                  <ThemeProvider>
                    <Router>
                      <Routes>
                        <Route path="/*" element={<App />} />
                      </Routes>
                    </Router>
                    <Toaster position="top-center" richColors closeButton />
                  </ThemeProvider>
                </SocialStoreProvider>
              </ShoppingStoreProvider>
            </AvatarStoreProvider>
          </SubscriptionStoreProvider>
        </NotificationStoreProvider>
      </QueryClientProvider>
    </React.StrictMode>
  )
}
